
define('text!templates/components/store_product/store_category.html',[],function () { return '<div class="category">\n    <div class=\'store-category\'>\n        <span class="category-name"><%= name %> :</span> \n        <span class="category-info"><%=info%></span>\n    </div>\n    <div class="gallery" id="<%= id %>_category" >\n\n    </div>\n</div>\n';});

